import React from 'react'
import { Typography } from 'antd'

const { Paragraph } = Typography

const Testimonials = (): React.ReactElement => {

  return (
    <div className="content-testimonials">
      <img src="/signup/testimonial-avatar.png" alt="" width={88} height={88} />
      <h3><span>“This is the exact product we were looking for.</span> We went from spreadsheets and manually entering PTO on a shared calendar to Vacation Tracker.”</h3>
      <Paragraph style={{ fontWeight: 700, marginBottom: 0 }}>Chris May Sikora</Paragraph>
      <Paragraph>Senior Creative Director, Spot</Paragraph>
    </div>
  )
}

export default Testimonials
